import { render, staticRenderFns } from "./TabsCadastro.vue?vue&type=template&id=9641adaa&scoped=true&"
import script from "./TabsCadastro.vue?vue&type=script&lang=js&"
export * from "./TabsCadastro.vue?vue&type=script&lang=js&"
import style0 from "./TabsCadastro.vue?vue&type=style&index=0&id=9641adaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9641adaa",
  null
  
)

export default component.exports